export default __webpack_public_path__ + "static/media/blog-permeable-vs-concrete-002.9cd1385e.jpg";